import { useTranslation } from 'react-i18next';

import FileDollarIcon from '@/components/atoms/Icons/FileDollarIcon';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

/**
 * EmptyInvoices - Empty state component shown when no invoices exist
 */
export const EmptyInvoices = () => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <FileDollarIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('invoices.empty_state.title')}</EmptyTitle>
        <EmptyDescription>
          {t('invoices.empty_state.description')}{' '}
          <a
            href={`mailto:${t('contact.billing_email')}`}
            className="font-medium text-primary hover:underline"
          >
            {t('contact.billing_email')}
          </a>
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
